import logService from '../services/wss/logService3';
import { subscribe } from '../services/utils/pubsub';
import { events } from '../services/wss/SystemEvents';
import CoreBase from '../services/engines/CoreBase';

/**
 *  THIS IS OBSOLETE DO NOT USE !
 *  USE CacheBase2
 *
 * difference with CacheBase2
 * is pub sub on onCleanup Event
 *
 */
export default class CacheBase extends CoreBase {
    /**
     * Initializes the cache with a name and subscribes to cleanup events.
     * @returns {boolean} true if cache is empty after init
     */
    init = (name) => {
        this._name = name;

        this.checkCache();
        this.subscribeCleanup();
        return this._items.length === 0;
    };

    subscribeCleanup = () => {
        // Remove existing handler before re-subscribing to prevent duplicates on React reload
        if (this.onClearCache) {
            this.onClearCache = this.onClearCache();
        }

        if (!this.onClearCache) {
            this.onClearCache = subscribe(events.onClearCache, (p) => this.cleanup(p));
        }
    };

    clear = () => {
        this._items = [];
    };

    /**
     * Clears cache and unsubscribes from cleanup event.
     */
    cleanup = () => {
        this._items = [];

        if (this.onClearCache) {
            this.onClearCache = this.onClearCache();
        }
    };

    checkCache = () => {
        if (this._items === undefined || this._items === null) {
            this._items = [];
        }
    };

    setCache = (items) => {
        this.checkCache();
        this._items = items;
    };

    getAll = () => {
        this.checkCache();
        return [...this._items];
    };

    get = (rk) => {
        try {
            const temp = this._items.find((x) => x.rk === rk);
            return temp ?? null;
        } catch (error) {
            logService.logError(`${this._name}.get: ex=${error.message}`);
        }
    };

    getCount = () => {
        this.checkCache();
        return this._items.length;
    };

    remove = (rk) => {
        try {
            const filtered = this._items.filter((x) => x.rk !== rk);
            this.setCache(filtered);
            return this.getAll();
        } catch (error) {
            logService.logError(`${this._name}.removeRowKey: ex=${error.message}`);
        }
    };
}
